import { createFileRoute } from '@tanstack/react-router';

import { CreateParkAndRideFacility } from '@/components/management/layout/CreateParkAndRideFacility';

export const Route = createFileRoute('/_authenticated/management/stationless/create')({
  component: CreateParkAndRideFacility,
  beforeLoad: async () => ({ breadcrumb: 'Neues Parkraumangebot' }),
});
